import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "op-sort-icon"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "op-sort-neutral"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["op-th", _ctx.thClass])
  }, [
    _createElementVNode("div", _mergeProps({ class: "op-th-label" }, _ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onLabelClick && _ctx.onLabelClick(...args)))
    }), [
      _renderSlot(_ctx.$slots, "default"),
      (_ctx.sort)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_ctx.isSortedAsc)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, "↑"))
              : (_ctx.isSortedDesc)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, "↓"))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "↕"))
          ]))
        : _createCommentVNode("", true)
    ], 16),
    (_ctx.resizable !== false && !_ctx.isLastColumn && !_ctx.isTouchDevice)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "op-resize-handle",
          onMousedown: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.startResize && _ctx.startResize(...args)), ["prevent","stop"])),
          onDblclick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetWidth && _ctx.resetWidth(...args)), ["prevent","stop"]))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 2))
}